// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-name-wrapper[data-v-28f4fdcf]{display:flex;align-items:center;grid-gap:.25rem}.comment-name-wrapper .verified-icon[data-v-28f4fdcf]{fill:#00c0f1;width:1rem;height:auto}", ""]);
// Exports
module.exports = exports;
